import React from 'react';
export function FooterSection() {
  return <footer className="bg-brand-dark text-brand-muted py-10 text-center text-sm px-4 border-t border-brand-border" data-id="element-100">
      <p className="font-medium tracking-wide" data-id="element-101">
        © 2026 P.E. READY — All Rights Reserved.
      </p>
    </footer>;
}